import script from "./WEBDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./WEBDashboard.vue?vue&type=script&setup=true&lang=js"

import "./WEBDashboard.vue?vue&type=style&index=0&id=e6885578&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6885578"]])

export default __exports__